import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { PensionContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionContributionInstruction";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { BankAccountsClient } from "../../../../../../Wrap/Api/BankAccounts/BankAccounts";
import { BankAccount } from "../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";
import { EditIncomeWithdrawalsInstructionDispatcher } from "../Stores/Variable";
import { ProcessType as ActivityType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { mapRestorePensionContributionModelDataToWrapType, mapWrapPensionContributionModelDataToWrapRestoreType } from "./EditIncomeWithdrawalsActionHelper";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";

export class EditIncomeWithdrawalsAction {
    public static getInstruction2(InstructionHierarchyId: string, hierarchyId: string, 
        subAccountHierarchyId: string,
         clientId: number, onInstructionLoadedCallback: (instructionId: string | null) => void = () => { }): void {
        const pensionContributionInstruction = new PensionContributionInstructionClient();
        if (CommonHelper.isNullOrEmpty(InstructionHierarchyId)) {
            pensionContributionInstruction
                .post(subAccountHierarchyId, hierarchyId, ActivityType.EditIncomeWithdrawals)
                .onSuccess((result) => {
                    const instructionId = result.Result;
                    const model = pensionContributionInstruction.get(instructionId, clientId, "editIncome");
                    model.onSuccess((result) => {
                        EditIncomeWithdrawalsInstructionDispatcher.dispatch({
                            actionType: ActionType.Success,
                            payload: mapWrapPensionContributionModelDataToWrapRestoreType(result),
                        });

                        onInstructionLoadedCallback(instructionId);
                    });
                });
        } else {
            pensionContributionInstruction.get(InstructionHierarchyId, clientId, "editIncome", 
                ).onSuccess((result) => {
                EditIncomeWithdrawalsInstructionDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload:  mapWrapPensionContributionModelDataToWrapRestoreType(result),
                });

                onInstructionLoadedCallback(InstructionHierarchyId);
            });
        }
    }

    public static saveInstruction2(data: PensionContributionModel, customerId?: number, callback?: (data) => void): void {
        const pensionContributionInstruction = new PensionContributionInstructionClient();
        let promise = pensionContributionInstruction.put(mapRestorePensionContributionModelDataToWrapType(data), customerId,null);
        promise.onSuccess((result) => {
            // update state from the server response
            const payload = mapWrapPensionContributionModelDataToWrapRestoreType(result)
            EditIncomeWithdrawalsInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: payload,
            });
            if (result.Errors != null && result.Errors.length > 0) {
                callback(result.Errors.map((ele) => ele.UserMessage));
            } else {
                callback(payload);
            }
        });

        promise.onError((err) => {
            EditIncomeWithdrawalsInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static submitInstruction(id, data, customerId, claccountId, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.put(id, data, customerId, claccountId);
        promise.onSuccess((result) => {
            if (callback) callback();
        });
    }

    public static deleteInstruction(id, callback?: VoidFunction): void {
        Promise.resolve(callback());
    }
}
